import { BoxProps, ComponentWithAs, Icon, IconProps, Text, VStack } from "@chakra-ui/react";

import { RanaLoading } from "@nens/ranalib";

interface ProjectFileStatusProps extends BoxProps {
  icon?: ComponentWithAs<"svg", IconProps>;
}

interface ProjectFileStatusWithProgressProps extends ProjectFileStatusProps {
  progress?: number;
}

export function ProjectFileStatus({ icon, children, ...rest }: ProjectFileStatusProps) {
  return (
    <VStack gap={2} color="brand.analytic" {...rest}>
      <Icon as={icon} boxSize={11} mb={1} />
      {children}
    </VStack>
  );
}

export function ProjectFileStatusWithProgress({
  progress,
  children,
  ...rest
}: ProjectFileStatusWithProgressProps) {
  return (
    <VStack gap={2} color="brand.analytic" {...rest}>
      <RanaLoading progress={progress ? progress * 100 : 0} boxSize={16} />
      <Text>{children}</Text>
    </VStack>
  );
}

export function ProjectFileStatusWithSpinner({ children, ...rest }: ProjectFileStatusProps) {
  return (
    <VStack gap={2} color="brand.analytic" {...rest}>
      <RanaLoading boxSize={16} />
      <Text>{children}</Text>
    </VStack>
  );
}
